import lightbox from "./utils/lightbox";
import ifscroll from "./utils/ifscroll";
import dropdown from "./utils/dropdown";

function swapClass(el, incls, outcls){
    el.removeClass(outcls);
    el.addClass(incls);
}

function themeComments(mode){
    let comments = $(".comments");
    if (comments && comments.length > 0){
        let config = comments.find('script[data-color-scheme]');
        if(config && config.length > 0){
            config.attr("data-color-scheme", mode);
        }
    }
}

function toggleDrawer(){
    let drawer = $(".drawer-v");
    if(drawer.hasClass("open")) {
        drawer.css("height", '');
        drawer.removeClass("open");
    } else {
        drawer.addClass("invisible");
        drawer.addClass("open");
        let height = drawer.height();
        drawer.removeClass("open");
        drawer.removeClass("invisible");
        drawer.addClass("open");
        drawer.css("height", '0px');
        setTimeout(()=>{
            drawer.css("height", `${height}px`);
        }, 1);
    }
}

function setTheme(tmode){
    let root = $("html");
    let alt = (["light", "dark"]).find(mode => tmode != mode);
    if(!root.hasClass(tmode)){
        swapClass(root, tmode, alt);
    }
    themeComments(tmode);
}

function toggleTheme(){
    let root = $("html");
    if(!root.hasClass("auto")){
        return;
    }
    let next = root.hasClass("light") ? "dark" : "light"
    setTheme(next);
    localStorage.setItem("tmode", next);
}

$(self.document).ready(function () {
    dropdown(self, self.document);
    ifscroll(self, self.document);
    lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img')
    $(".content").fitVids();
    $(".menu-btn").click(toggleDrawer);
    $("button[data-ghost-tmode]").click(toggleTheme);
    let tmode = localStorage.getItem("tmode") ?? "auto";
    tmode = $("html").hasClass("dark") ? "dark" : tmode;
    tmode = $("html").hasClass("light") ? "light" : tmode;
    setTheme(tmode === "auto" ? "light" : tmode)
});
